
/* injects from baggage-loader */
require('./style.styl');

import React, {Children} from 'react'
import PropTypes from 'prop-types'
import ContainerDimentionsContext from 'components/ContainerDimentionsContext'
import FunnelChartWithContext from './FunnelChartWithContext'
import ChannelSelect from 'components/ChannelSelect'
import Icon from 'components/Icon'
import Loader from 'components/Loader'
import classnames from 'classnames'
import get from 'lodash/get'

export default class FunnelChartTable extends React.Component {
  static propTypes = {
    height: PropTypes.number,
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    loading: PropTypes.bool,
    channel: PropTypes.shape({
      channelGroupId: PropTypes.string,
      channelId: PropTypes.string
    }),
    index: PropTypes.number,
    onSelect: PropTypes.func,
    onRemove: PropTypes.func,
    availableChannels: PropTypes.object
  }

  render() {
    return (
      <div className='funnel-table'>
        {this.renderHeader()}
        {this.renderBody()}
        {this.renderFooter()}
      </div>
    )
  }

  renderHeader() {
    const {
      channel,
      onSelect,
      availableChannels
    } = this.props

    return (
      <div className='funnel-table_header'>
        <div className='funnel-table_header_channel-header'>{this.renderChannelHeader()}</div>
        <div className='funnel-table_header_average-header'>
          Total
        </div>
        <div className='funnel-table_header_channel-controls'>
          <ChannelSelect
            value={channel}
            onSelect={onSelect}
            availableChannels={availableChannels}
          />
        </div>
      </div>
    )
  }

  renderChannelHeader() {
    const {channel: value} = this.props
    if (!value) return null

    const {channelGroupId, channelId} = value
    if (!channelId) {
      return 'Group'
    } else if (channelId && channelGroupId) {
      return 'Channel'
    }
  }

  renderBody() {
    const {data, height, loading} = this.props
    const classNames = classnames('funnel-table_body', {
      'is-loading': loading,
      'is-empty': !data
    })

    return (
      <div className={classNames} style={{height}}>
        {this.renderBodyContent()}
      </div>
    )
  }

  renderBodyContent() {
    const {data, loading} = this.props
    const columns = this.getColumns()

    if (loading) return <Loader />
    if (!loading && !data) {
      return (
        <div className='funnel-table_body_empty'>
          There is no data for this channel.
        </div>
      )
    }
    return columns.map((column, index) => {
      const {children, width, grow, className} = column.props
      const columnClassName = classnames('funnel-table_column', {'is-grow': grow}, className)

      return (
        <div className={columnClassName} style={{flexBasis: width}} key={index}>
          {children ? this.renderChartColumn(column) : this.renderDataColumn(column)}
        </div>
      )
    })
  }

  renderFooter() {
    const {
      onRemove,
      index
    } = this.props

    if (index === 0) {
      return <div className='funnel-table_footer' />
    } else {
      return (
        <div className='funnel-table_footer'>
          <div className='funnel-table_remove' onClick={onRemove}>
            <Icon name='cross' size='9px' /> Remove Funnel
          </div>
        </div>
      )
    }
  }

  renderDataColumn(column) {
    const {dataKey, dataFormat, cell, label} = column.props
    const {data} = this.props
    if (!data) return null

    const classNames = classnames('funnel-table_legend', {
      'is-label': label
    })

    return (
      <div className={classNames}>
        {Object.keys(data).map((key, index) => {
          return dataKey.map((dataKey, i) => {
            const value = get(data, `${key}.${dataKey}`)
            const format = dataFormat && dataFormat[i]
            return (
              <div className='funnel-table_legend-item' key={`${index}_${i}`}>
                {cell ? cell(value, format) : value}
              </div>
            )
          })
        })}
      </div>
    )
  }

  renderChartColumn(column) {
    const {height, data, loading} = this.props
    const {children} = column.props

    return (
      <ContainerDimentionsContext className='funnel-table_chart'>
        <FunnelChartWithContext height={height} data={data} loading={loading}>
          {children}
        </FunnelChartWithContext>
      </ContainerDimentionsContext>
    )
  }

  getColumns() {
    return Children.toArray(this.props.children)
  }
}



// WEBPACK FOOTER //
// ./client/components/Chart/FunnelChartTable/index.js